import React, { FC } from 'react';
import './VerticalStepper.scss';

export type ISubStep = {
  title: string;
  date: string;
  description: string;
};

export type IStep = {
  title: string;
  titleColor: string;
  icon: React.ReactNode;
  subSteps?: ISubStep[];
  isOpaque?: boolean;
};

interface VerticalStepperProps {
  steps: IStep[];
}

/**
 * Componente de stepper vertical anidado que muestra los pasos de un proceso
 * con secciones agrupadas y subpasos individuales conectados por líneas verticales
 */
const VerticalStepper: FC<VerticalStepperProps> = ({ steps }) => {
  return (
    <div className="verticalStepper">
      {steps.map(({ subSteps, ...step }, stepIdx) => {
        const hasSubSteps = subSteps && subSteps.length > 0;
        const opacityClass = step.isOpaque ? 'subStepOpaque' : '';
        const emptySubStepsContainerClass = !hasSubSteps ? 'emptySubStepsContainer' : '';

        return (
          <div key={stepIdx} className={`stepContainer ${opacityClass}`}>
            <div className="stepLine"></div>
            <div className="stepHeader">
              <div className="stepIconContainer">{step.icon}</div>
              <p className={`stepTitle ${step.titleColor}`}>{step.title}</p>
            </div>

            <div className={`subStepsContainer ${emptySubStepsContainerClass}`}>
              {hasSubSteps &&
                subSteps.map((subStep, subStepIdx) => (
                  <div key={subStepIdx} className="subStepContent">
                    <div className="subStepLine"></div>
                    <div className="subStepHeader">
                      <div className="subStepCircle"></div>
                      <div className="subStepHeaderContent">
                        <span className="subStepTitle">{subStep.title}</span>
                        <span className="subStepDate">{subStep.date}</span>
                        <p className="subStepDescription">{subStep.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              {!hasSubSteps && <div className="emptySubStepSpacer"></div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VerticalStepper;
